import { useQuery } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export const getPhotosOptions = (sessionId: string) => trpcOptions.app.getPhotos.queryOptions({ sessionId })

export function useGetPhotos(sessionId: string) {
  return useQuery(getPhotosOptions(sessionId))
}
